export default function getLanguageFromPath(url: string): string | undefined {
    const parts = url.split("/");
    return parts.length > 1 ? parts[1] : undefined;
}